export const pgaTypes = {
  TC: "TC",
  ECCC: "ECCC",
  CFIA: "CFIA",
  NRCan: "NRCan",
  CNSC: "CNSC",
  GAC: "GAC",
  HC:"HC",
  DFOTradeTracking:"DFOTradeTracking",
  DFOAquaticBiotechnology:"DFOAquaticBiotechnology",
  DFOAquaticInvasiveSpecies:"DFOAquaticInvasiveSpecies"
};

export const allPossiblePgaTypes = {
  cnscFlag: 2,
  dfoFlag: 2,
  ecccFlag: 2,
  hcFlag: 2,
  nrcanFlag: 2,
  cfiaFlag: 2,
  gacFlag: 2,
  phacFlag: 2,
  tcFlag: 2,
  dfoTradeTrackingFlag:2,
  dfoAquaticBiotechnologyFlag:2,
  dfoAquaticInvasiveSpeciesFlag:2
};
